export default __webpack_public_path__ + "static/media/a1.f453f8ed.png";